export const LOGO_URL = 'https://customer-assets.emergentagent.com/job_treffpunkt-demo/artifacts/8mckpxjl_logo%20treff-Photoroom.png';

export const IMAGES = {
  birthday: 'https://customer-assets.emergentagent.com/job_d41bd410-fd28-4a3a-8701-2681031ee91a/artifacts/ziq6r8zt_Gemini_Generated_Image_cgw44rcgw44rcgw4.png',
  terrace: 'https://customer-assets.emergentagent.com/job_d41bd410-fd28-4a3a-8701-2681031ee91a/artifacts/0lcch5lc_Gemini_Generated_Image_cgdwukcgdwukcgdw.png',
  barCounter: 'https://customer-assets.emergentagent.com/job_d41bd410-fd28-4a3a-8701-2681031ee91a/artifacts/7bdcvq6e_Gemini_Generated_Image_ovw9a6ovw9a6ovw9.png',
  lounge: 'https://customer-assets.emergentagent.com/job_d41bd410-fd28-4a3a-8701-2681031ee91a/artifacts/kx8i07ag_Gemini_Generated_Image_cwy4kgcwy4kgcwy4.png',
  football: 'https://customer-assets.emergentagent.com/job_d41bd410-fd28-4a3a-8701-2681031ee91a/artifacts/aaesyw0z_Gemini_Generated_Image_bofsv8bofsv8bofs.png',
  darts: 'https://images.unsplash.com/photo-1565073624497-7144969d0a07?w=800&q=80',
  cocktails: 'https://images.unsplash.com/photo-1772311698901-fe3fa07141be?w=800&q=80',
  latte: 'https://images.unsplash.com/photo-1583124688253-60c350bc90d7?w=800&q=80',
};

export const MENU_DATA = {
  cocktails: {
    label: 'Cocktails',
    items: [
      { name: 'Mojito', desc: 'Rum, Limette, Minze, Soda', price: 'CHF 14.50' },
      { name: 'Aperol Spritz', desc: 'Aperol, Prosecco, Soda', price: 'CHF 13.00' },
      { name: 'Espresso Martini', desc: 'Vodka, Espresso, Kaffeelikör', price: 'CHF 15.00' },
      { name: 'Caipirinha', desc: 'Cachaça, Limette, Rohrzucker', price: 'CHF 14.00' },
      { name: 'Long Island Iced Tea', desc: 'Vodka, Rum, Gin, Tequila, Cola', price: 'CHF 16.00' },
      { name: 'Cosmopolitan', desc: 'Vodka, Cointreau, Cranberry', price: 'CHF 14.50' },
    ]
  },
  kaffee: {
    label: 'Kaffee',
    items: [
      { name: 'Espresso', desc: 'Klassisch italienisch', price: 'CHF 4.50' },
      { name: 'Cappuccino', desc: 'Espresso mit Milchschaum', price: 'CHF 5.50' },
      { name: 'Latte Macchiato', desc: 'Geschichteter Milchkaffee', price: 'CHF 6.00' },
      { name: 'Café Crème', desc: 'Schweizer Klassiker', price: 'CHF 5.00' },
      { name: 'Flat White', desc: 'Doppelter Espresso, samtige Milch', price: 'CHF 5.50' },
    ]
  },
  bier: {
    label: 'Bier',
    items: [
      { name: 'Feldschlösschen', desc: 'Lager, 3dl', price: 'CHF 5.50' },
      { name: 'Heineken', desc: 'Lager, 3dl', price: 'CHF 6.00' },
      { name: 'Corona', desc: 'Pale Lager, 3.3dl', price: 'CHF 7.00' },
      { name: 'Weizenbier', desc: 'Hefeweizen, 5dl', price: 'CHF 8.50' },
      { name: 'Erdinger Alkoholfrei', desc: 'Weizen, 3.3dl', price: 'CHF 6.00' },
    ]
  },
  wein: {
    label: 'Wein',
    items: [
      { name: 'Hauswein Rot', desc: 'Trocken, 1dl', price: 'CHF 5.50' },
      { name: 'Hauswein Weiss', desc: 'Trocken, 1dl', price: 'CHF 5.50' },
      { name: 'Prosecco', desc: 'Glas', price: 'CHF 7.00' },
      { name: 'Rosé', desc: 'Provence, 1dl', price: 'CHF 6.50' },
      { name: 'Champagner', desc: 'Glas', price: 'CHF 14.00' },
    ]
  },
  softdrinks: {
    label: 'Softdrinks',
    items: [
      { name: 'Coca Cola', desc: '3dl', price: 'CHF 4.50' },
      { name: 'Rivella', desc: 'Rot oder Blau, 3dl', price: 'CHF 4.50' },
      { name: 'Red Bull', desc: '2.5dl', price: 'CHF 6.00' },
      { name: 'Mineralwasser', desc: 'Still oder prickelnd, 5dl', price: 'CHF 4.00' },
      { name: 'Eistee', desc: 'Pfirsich oder Zitrone, 3dl', price: 'CHF 4.50' },
    ]
  },
  snacks: {
    label: 'Snacks',
    items: [
      { name: 'Nachos mit Dip', desc: 'Käse & Salsa', price: 'CHF 9.50' },
      { name: 'Bruschetta', desc: 'Tomaten, Basilikum, Knoblauch', price: 'CHF 8.50' },
      { name: 'Oliven & Brot', desc: 'Marinierte Oliven, Ciabatta', price: 'CHF 7.00' },
      { name: 'Nüssli Mix', desc: 'Geröstete Nüsse', price: 'CHF 5.50' },
      { name: 'Flammkuchen', desc: 'Speck, Zwiebeln, Crème fraîche', price: 'CHF 12.00' },
    ]
  }
};

export const EVENTS_DATA = [
  {
    title: 'Live Fussball Nächte',
    desc: 'Alle wichtigen Spiele live auf Grossleinwand. Champions League, Bundesliga, EM und WM.',
    image: IMAGES.football,
    tag: 'Sport',
  },
  {
    title: 'Geburtstage feiern',
    desc: 'Feiere deinen besonderen Tag bei uns. Wir organisieren alles für dich und deine Gäste.',
    image: IMAGES.birthday,
    tag: 'Privat',
  },
  {
    title: 'Private Events',
    desc: 'Firmenanlässe, Teamevents oder Familientreffen. Wir bieten den perfekten Rahmen.',
    image: IMAGES.lounge,
    tag: 'Events',
  },
  {
    title: 'Film- & Themenabende',
    desc: 'Von Quiznight bis Karaoke. Bei uns ist immer etwas los.',
    image: IMAGES.terrace,
    tag: 'Unterhaltung',
  },
];

export const NAV_LINKS = [
  { label: 'Erlebnis', href: '#erlebnis' },
  { label: 'Karte', href: '#karte' },
  { label: 'Events', href: '#events' },
  { label: 'Galerie', href: '#galerie' },
  { label: 'Kontakt', href: '#kontakt' },
];
